<template>
  <div class="card-dropdown custom-breadcrumb" style="background-color: #FFFFFF;">
    <div class="ml-4 pt-1 pb-1" :key="index" v-for="(item, index) in list">
      <span class="active" v-if="isLast(index)" style=" font-weight: bold;">{{ showName(item) }}</span>
      </div>
<!--

  <ol class="pl-0" style="background-color: #FFFFFF;">
    <li class="pl-4" :key="index" v-for="(item, index) in list">
      <span class="active" v-if="isLast(index)" style=" font-weight: bold;">{{ showName(item) }}</span>

      <router-link :to="item" v-else>{{ showName(item) }}</router-link>

    </div>
  </ol>
    -->
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    isLast (index) {
      return index === this.list.length - 1
    },
    showName (item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label
      }

      if (item.name) {
        item = item.name
      }
      return item
    }
  }
}
</script>
<style>
.custom-breadcrumb {
  position: fixed !important;
  bottom: 0;
  right: 0;
  top: 55px;
  height: 50px;
  z-index:500;
  transition: margin-left 0.25s, margin-right 0.25s, width 0.25s, flex 0.25s, -webkit-box-flex 0.25s, -ms-flex 0.25s;
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue